export default __webpack_public_path__ + "static/media/checkPin.7b539da5.svg";